/** Shared MITRE ATT&CK documentation URL + id helpers for EDR detail screens. */

export const getMitreTechniqueDocsUrl = (mitreId: string): string => {
  const clean = mitreId.trim().toUpperCase();
  const [technique, sub] = clean.split('.');
  return sub
    ? `https://attack.mitre.org/techniques/${technique}/${sub}/`
    : `https://attack.mitre.org/techniques/${clean}/`;
};

export const collectMitreIds = (
  mitreId?: string | null,
  mitreIds?: string[] | null
): string[] => {
  const fromList = (mitreIds ?? []).map((id) => id?.trim()).filter(Boolean) as string[];
  if (fromList.length) return Array.from(new Set(fromList));
  return mitreId?.trim() ? [mitreId.trim()] : [];
};
